import { Pagination } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubscribe } from '../Redux/Slice/subscribe.slice';
import { motion } from 'framer-motion';
import { FaSearch, FaBell, FaEnvelope } from 'react-icons/fa';

export default function Subscriber() {
    const [searchValue, setSearchValue] = useState('');
    const dispatch = useDispatch();
    const { Subscribe } = useSelector((state) => state.subscribe);

    const filteredData = Subscribe.filter(data => (
        data?.email?.toLowerCase().includes(searchValue.toLowerCase())
    ));

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentItems = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    useEffect(() => {
        dispatch(getAllSubscribe());
    }, [dispatch])

    return (
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div>
                    <h1 className="text-3xl font-bold text-white tracking-tight">Email Subscribers</h1>
                    <p className="text-gray-400">Manage your newsletter audience.</p>
                </div>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-3xl overflow-hidden backdrop-blur-sm">
                <div className="p-6 border-b border-white/5 flex flex-col sm:flex-row gap-4 items-center justify-between">
                    <div className="relative w-full sm:w-80 group">
                        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 group-focus-within:text-primary transition-colors" />
                        <input
                            type="text"
                            placeholder="Search by email..."
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            className="w-full bg-white/5 border border-white/10 rounded-xl pl-12 pr-4 py-2.5 text-sm text-white focus:border-primary/50 outline-none transition-all"
                        />
                    </div>
                    <p className="text-xs font-bold text-gray-500 uppercase tracking-widest">
                        Total Audience: {filteredData.length}
                    </p>
                </div>

                <div className="overflow-x-auto no-scrollbar">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-white/[0.02]">
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest w-16 text-center">Index</th>
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest">Email Identity</th>
                                <th className="px-6 py-3 text-xs font-bold text-gray-500 uppercase tracking-widest text-center">Engagement Status</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/5">
                            {currentItems.map((sub, index) => (
                                <tr key={index} className="hover:bg-white/[0.02] transition-colors group">
                                    <td className="px-6 py-4 text-center">
                                        <span className="text-xs text-gray-600 font-bold">{(currentPage - 1) * itemsPerPage + index + 1}</span>
                                    </td>
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
                                                <FaEnvelope size={14} />
                                            </div>
                                            <span className="text-sm font-bold text-white group-hover:text-primary transition-colors">{sub?.email}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-center">
                                        <span className={`px-4 py-1.5 rounded-xl text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-2 mx-auto w-fit ${sub?.subscribe ? 'bg-green-500/10 text-green-400 border border-green-500/20' : 'bg-red-500/10 text-red-400 border border-red-500/20'}`}>
                                            <FaBell className={sub?.subscribe ? 'animate-pulse' : ''} />
                                            {sub?.subscribe ? 'Active' : 'Unsubscribed'}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                             {currentItems.length === 0 && (
                                <tr>
                                    <td colSpan="3" className="px-8 py-12 text-center text-gray-500 italic">No subscribers found matching your search.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalPages > 1 && (
                    <div className="p-6 border-t border-white/5 flex justify-end">
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={(_, page) => handlePageChange(page)}
                            sx={{
                                "& .MuiPaginationItem-root": { color: "#9ca3af", borderColor: "rgba(255,255,255,0.1)", borderRadius: "12px" },
                                "& .Mui-selected": { backgroundColor: "rgba(98,99,237,0.2) !important", color: "#6263ED !important", borderColor: "rgba(98,99,237,0.5) !important" }
                            }}
                        />
                    </div>
                )}
            </div>
        </motion.div>
    )
}